import React from 'react';
import { connect } from 'react-redux';

import HyperButtons from '../blocks/HyperButtons';
import Manager from '../blocks/Manager';



const SsapHyperDashboard = props => {

    const {
        adjustedFlow,
        page,
        data,
        data: {
            taxHousehold: {
                householdMember: householdMembers
            }
        }
    } = props;

    return (
        <div>
            <HyperButtons { ...{ adjustedFlow, page, data, householdMembers } }/>
            <Manager
                { ...{
                    buttons: {
                        TaxHouseholdComposition: false,
                        Pages: false,
                        Flags: false,
                        Identifiers: false,
                        JsonSetter: false,
                        JsonGetter: false,
                        Relations: false,
                        Attestations: false,
                        EscPageRender: false
                    }
                } }
            />
        </div>
    );
};

const mapStateToProps = state => ({
    adjustedFlow: state.ssap.adjustedFlow,
    data: state.ssap.data,
    page: state.ssap.page
});

export default connect(mapStateToProps)(SsapHyperDashboard);
